import { Component, ElementRef, Input, OnInit } from '@angular/core';
import { MarketPlacePersonalizationUtils } from '@app-components/layouts/shopkeeper-layout/marketplace-personalization';
import { OpenService } from '@app-services/open.service';

@Component({
  selector: 'app-card-title',
  templateUrl: './card-title.component.html',
  styleUrls: ['./card-title.component.scss']
})
export class CardTitleComponent implements OnInit {

  @Input() title: string;
  @Input() icon: string;
  @Input() iconBody: string;

  titleColor: string = 'var(--button-branded4)';
  constructor(
    private elRef: ElementRef,
    private openService: OpenService
  ) { }

  ngOnInit(): void {
    this.openService.getLayoutVars().subscribe((layoutVars) => {
      if(layoutVars) {
        this.titleColor = MarketPlacePersonalizationUtils.getColorNotWhite(['offerColor', 'primaryColor', 'buttonColor'], layoutVars);
      }
    });
  }

}
